import {
  EMPLOYEE_MANAGEMENT_SERVICE,
  MAGENTO_ADMIN_SERVICE,
  restApiRequest,
} from "src/utils/Api";
import { dynamicNotification } from "src/utils/Notifications";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";
import __ from "src/utils/Translations";

export const ORDER_NUMBER_FILTER_ID = "orderNumber";
export const ORDER_ID_QUERY_PARAM = "orderId";

export const getOrderIdFromSearch = (search) =>
  new URLSearchParams(search).get(ORDER_ID_QUERY_PARAM)?.trim() || null;

export const clearOrderIdFromUrl = (history, location) => {
  const params = new URLSearchParams(location.search);

  if (!params.has(ORDER_ID_QUERY_PARAM)) {
    return;
  }

  params.delete(ORDER_ID_QUERY_PARAM);
  const search = params.toString();

  history.replace({
    pathname: location.pathname,
    search: search ? `?${search}` : "",
    hash: location.hash,
  });
};

export const getOrderNumberFromFilters = (filters) => {
  const orderNumberFilter = filters.find(
    (filter) => filter.id === ORDER_NUMBER_FILTER_ID
  );

  return orderNumberFilter?.value?.trim() || null;
};

export const excludeOrderNumberFilter = (filters) =>
  filters.filter((filter) => filter.id !== ORDER_NUMBER_FILTER_ID);

export const searchEmployeeByOrderNumber = (orderNumber) => {
  const trimmedOrderNumber = orderNumber?.trim();

  if (!trimmedOrderNumber) {
    return Promise.resolve(null);
  }

  return restApiRequest(
    MAGENTO_ADMIN_SERVICE,
    `/order-employee-id/${encodeURIComponent(trimmedOrderNumber)}`,
    "GET",
    {},
    {}
  );
};

export const fetchEmployeeById = (employeeId) =>
  restApiRequest(
    EMPLOYEE_MANAGEMENT_SERVICE,
    `/employees/${employeeId}`,
    "GET",
    {},
    {}
  );

export const buildEmployeeOrderRedirectUrl = ({
  employeeId,
  companyId,
  orderId,
  isAhr,
}) => {
  const orderQuery = `?${ORDER_ID_QUERY_PARAM}=${encodeURIComponent(
    String(orderId)
  )}`;

  if (isAhr) {
    return `/ahr/employees/${employeeId}${orderQuery}#one_time_services`;
  }

  return `/company/edit/${companyId}/employee-management/employees/${employeeId}${orderQuery}#one_time_services`;
};

export const tryRedirectToEmployeeByOrderNumber = async ({
  orderNumber,
  isAhr,
  history,
  errorContext,
}) => {
  if (!orderNumber) {
    return false;
  }

  try {
    const response = await searchEmployeeByOrderNumber(orderNumber);

    if (!response?.employeeId || !response?.orderId) {
      dynamicNotification(__("Nie znaleziono zamówienia"), "error");
      return true;
    }

    let companyId = null;

    if (!isAhr) {
      const employee = await fetchEmployeeById(response.employeeId);
      companyId = employee?.companyId;

      if (!companyId) {
        dynamicNotification(
          __("Nie udało się przekierować do zamówienia"),
          "error"
        );
        return true;
      }
    }

    history.push(
      buildEmployeeOrderRedirectUrl({
        employeeId: response.employeeId,
        companyId,
        orderId: response.orderId,
        isAhr,
      })
    );
    return true;
  } catch (e) {
    console.error(e);
    newRelicErrorReport(e, errorContext);
    dynamicNotification(e.message || __("Nie znaleziono zamówienia"), "error");
    return true;
  }
};
